import useTranslation from 'next-translate/useTranslation'

import Button from '@/atoms/TempButton'
import { setStagingProduct } from '@/store/slices/cart'
import { showModal } from '@/store/slices/modal'
import { CartItem } from '@/ts/Cart'
import Product from '@/ts/Product'

function AllSlotsButton({ product }: AllSlotsButtonProps) {
  const { t } = useTranslation('products')

  const onClick = () => {
    setStagingProduct(product as CartItem)
    showModal('cart', 'all_time_slots')
  }

  return (
    <Button
      onClick={onClick}
      className="w-full max-w-xs p-3 font-medium"
      variant="rounded"
    >
      {t('see_all_time_slots')}
    </Button>
  )
}

interface AllSlotsButtonProps {
  product: Product
}

export default AllSlotsButton
